import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams} from 'ionic-angular';

import { DatabaseProvider } from '../../providers/database/database';

import { ProductionAddPage } from '../production-add/production-add';
//import { ProductionItem } from './productionitem';

/**
 * Generated class for the ProductionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-production',
  templateUrl: 'production.html',
})
export class ProductionPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public dbProvider: DatabaseProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProductionPage');
  }

  addProduction(){
    console.log('addProduction() called...');
    this.navCtrl.push(ProductionAddPage, {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/production/production.ts